// extracted by mini-css-extract-plugin
export default {"basic-panel":"AILogsTable_basic-panel__6nG-y","disabled":"AILogsTable_disabled__Ar7fz"};